import { Action, createReducer, on } from '@ngrx/store';
import { BadResponseWithError } from '../../models/bad-response-with-error.interface';
import { UploadMediaActions } from '../action/actions-type.action';
import { StoredUploadedImage } from '@shared/models/media.model';

export interface MediaState {
    isLoading: boolean;
    error: BadResponseWithError | null;
    uploadedImages?: StoredUploadedImage[];
}

const initialState: MediaState = {
    isLoading: false,
    error: null,
    uploadedImages: [],
};

const reducer = createReducer(
    initialState,
    on(UploadMediaActions.uploadImageFile, (state, action) => ({
        ...state,
        isLoading: true,
    })),
    on(UploadMediaActions.uploadImageFileSuccess, (state, action) => {
        const existingIndex = state.uploadedImages?.findIndex(
            (img) =>
                img.domain === action.payload.domain &&
                img.mediaType === action.payload.mediaType &&
                img.targetId === action.payload.targetId
        );

        let updatedImages: StoredUploadedImage[];
        if (existingIndex !== undefined && existingIndex !== -1) {
            updatedImages = [...(state.uploadedImages || [])];
            updatedImages[existingIndex] = {
                ...updatedImages[existingIndex],
                id: action.id,
            };
        } else {
            updatedImages = [
                ...(state.uploadedImages || []),
                { ...action.payload, id: action.id },
            ];
        }

        return {
            ...state,
            isLoading: false,
            uploadedImages: updatedImages,
        };
    }),
    on(UploadMediaActions.uploadImageFileFailure, (state, action) => ({
        ...state,
        isLoading: false,
        error: action.payload,
    }))
);

export const mediaReducer = (state: MediaState, action: Action) =>
    reducer(state, action);
